// extracted by mini-css-extract-plugin
export const header = "home-module--header--25SFx";
export const btn = "home-module--btn--2Jhvd";